// @flow

// Libs
import React, { Component } from 'react'
import _map from 'lodash/map'

// Components
import HeftyField from './HeftyField'

// Constants
import {
  PROP_ASSET_ID,
  PROP_PARENT,
} from 'fc-model-assets'

// Types
import type {
  Asset,
} from 'fc-model-assets/types'

type Props = {
  fieldsToRenderOnMap: Asset,
  farms: Asset,
  selectedFieldId: ?number,
  selectedFeatureIndex: ?number,
  hoverFeatureIndex: ?number,
  onSelectFeature: Function,
  onToggleHoverFeature: Function,
}
class HeftyFields extends Component {
  props: Props
  render (): React.Element<any> {
    const { fieldsToRenderOnMap, farms } = this.props
    return (
      <div data-test='hefty-fields'>
        {
          _map(fieldsToRenderOnMap, (field: Asset, i: number): React.Element<any> => {
            const { selectedFeatureIndex, hoverFeatureIndex } = this.props
            const isSelected = field[PROP_ASSET_ID] === this.props.selectedFieldId

            return (
              <HeftyField
                field={field}
                farm={farms[field[PROP_PARENT]] || {}}
                selected={isSelected}
                selectedFeatureIndex={selectedFeatureIndex}
                hoverFeatureIndex={hoverFeatureIndex}
                key={`field-${i}`}

                // Actions
                onSelectFeature={this.props.onSelectFeature}
                onToggleHoverFeature={this.props.onToggleHoverFeature}
              />
            )
          })
        }
      </div>
    )
  }
}

export default HeftyFields
